import { Badge } from 'react-bootstrap';

/**
 * Reusable badge component for displaying benefit status.
 */
const UserTypeBadge = ({ userType, userAgency }) => {
  const INTERNAL_AGENCY = 'MDU';

  const getUserTypeBadgeVariant = (userType, userAgency) => {
    switch (userType) {
      case 20: return 'user-type-admin';
      case 30: return 'user-type-manager';
      case 40: return 'user-type-master';
      case 10:
        if (userAgency === INTERNAL_AGENCY) return 'user-type-internal-user';
      default: return 'user-type-user';
    }
  };

  const getUserTypeLabel = (userType, userAgency) => {
    switch (userType) {
      case 20: return 'Admin';
      case 30: return 'User Manager';
      case 40: return 'Master';
      case 10:
        if (userAgency === INTERNAL_AGENCY) return 'Internal User';
        else return 'Agency User';
      default: return 'Unknown';
    }
  };

  return <Badge bg={getUserTypeBadgeVariant(userType, userAgency)}>{getUserTypeLabel(userType, userAgency)}</Badge>;
};

export default UserTypeBadge;